import React from 'react';
import { Label } from './ui/label';
import { Asterisk } from 'lucide-react';

interface LabelWithAsteriskProps {
    label: string;
    className?: string; // optional className
}

const LabelWithAsterisk: React.FC<LabelWithAsteriskProps> = ({
    label,
    className = ''
}) => {
    return (
        <div className={`flex items-center ${className}`}>
            <Label>{label}</Label>
            <Asterisk size={16} color='red'/>
        </div>
    );
};

export default LabelWithAsterisk;
